import classNames from '@sindresorhus/class-names';
import Image from 'next/image';
import Link from 'next/link';
import {useState} from 'react';

import Services from '@shared/Articles/assets/Category_20.svg';
import Sparkle from '@shared/Articles/assets/Sparkle_20.svg';

import {CategoriesType} from '@strapi/types/Categories';

import styles from './CategoryMenu.module.scss';

const MAX_SHORT_DESCRIPTION_LENGTH = 150;
const staticChips = [
  {
    id: 1,
    categoryUrl: '',
    categoryName: ' Интересное',
    categoryIcon: {url: Sparkle},
  },
  {
    id: 2,
    categoryUrl: 'all',
    categoryName: 'Все статьи',
    categoryIcon: {url: Services},
  },
];

export const CategoryMenu = ({
  categories,
  currentCategoryUrl,
  categoryDescription,
  basePath = 'prostore',
  menuItemClickAnalytics,
}: {
  categories: CategoriesType[];
  currentCategoryUrl: string;
  categoryDescription?: string;
  basePath?: 'prostore' | 'blog';
  menuItemClickAnalytics?: (category: string) => void;
}) => {
  const [isFullDescription, setIsFullDescription] = useState(false);
  const sortedCategories = categories.sort((a, b) => {
    if (a.positionNumber === null && b.positionNumber === null) {
      return 0;
    }
    if (a.positionNumber === null) {
      return 1;
    }
    if (b.positionNumber === null) {
      return -1;
    }
    return Number(a.positionNumber) - Number(b.positionNumber);
  });

  const categoriesWithStaticChips = [...staticChips, ...sortedCategories];
  const chipsChunks = () => {
    const middleIndex = Math.ceil(categoriesWithStaticChips.length / 2);
    const firstHalf = categoriesWithStaticChips.slice(0, middleIndex);
    const secondHalf = categoriesWithStaticChips.slice(middleIndex);

    return [firstHalf, secondHalf];
  };

  const handleMenuItemClick = (category: string) => {
    if (menuItemClickAnalytics) {
      return menuItemClickAnalytics(category);
    }
  };
  return (
    <div className={styles.menu}>
      <div className={styles.container}>
        {chipsChunks().map(
          (elem, index) =>
            elem.length > 0 && (
              <div className={styles.chips} key={index}>
                {elem.map((chip) => (
                  <Link
                    key={chip.categoryUrl}
                    className={classNames(styles.chip, {
                      [styles.active]: currentCategoryUrl === chip.categoryUrl,
                    })}
                    href={
                      chip.categoryUrl === ''
                        ? `/${basePath}`
                        : `/${basePath}/categories/${chip.categoryUrl}`
                    }
                    onClick={() => handleMenuItemClick(chip.categoryName)}
                    data-testid={
                      chip.categoryUrl === 'all'
                        ? `category_chip_all`
                        : `category_chip`
                    }
                  >
                    {chip.categoryIcon?.url && (
                      <Image
                        src={chip.categoryIcon.url}
                        width={20}
                        height={20}
                        alt=""
                        className={styles.icon}
                      />
                    )}
                    {chip.categoryName}
                  </Link>
                ))}
              </div>
            ),
        )}
      </div>

      {categoryDescription && (
        <div
          className={classNames(styles.description, {
            [styles.full]: isFullDescription,
          })}
        >
          <p>{categoryDescription}</p>
          {categoryDescription.length > MAX_SHORT_DESCRIPTION_LENGTH && (
            <div
              className={styles.more}
              onClick={() => setIsFullDescription(!isFullDescription)}
            >
              {isFullDescription ? 'Скрыть' : 'Еще'}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
